import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import validators from "../utils/validators";
import parseUrl from "../utils/parseUrl";
import swal from "sweetalert";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";
import sendRequest from "../utils/sendRequest";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../utils/cipher";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 40,
        maxHeight: 500,
        width: 500,
        maxWidth: 900,
        background: '#EEEEEE',
        boxShadow: '0px 3px 15px #BCB0B0',
        borderRadius: 5,
    },

}));


const theme = createTheme();

const EmailForResetpassword = () => {
    const cardStyles = useStyles(theme);
    const queryParams = parseUrl(window.location.href);
    const [loader, setLoader] = useState(false);
    let navigate = useNavigate();
    // useEffect(() => {
    //     // alert(queryParams.token)
    // }, []);

    const [input, setInput] = useState({
        email: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            email: input.email.toLowerCase()
        }
        let encryptedPayload = encrypt(payload)

        if (input.email != '') {
            sendRequest(`/api/sebi/sendPasswordResetLink`, { payload: encryptedPayload }).then((result) => {

                if (result.type === "success") {
                    swal("Done", result.message, "success").then((result) => {
                        if (result) {
                            window.location.href ="https://pms.apmiindia.org/";
                        }
                    });

                }
                else {
                    swal("", result.message, "warning");
                }
            }).catch(err => {
                swal("", err, "warning");
            })

        }
        else {
            swal("", "Failed to Send reset Password Link", "warning");
        }

    }

    return (
        <div >
            <ThemeProvider theme={theme}>
                <Navbar />
                <Loader visible={loader} />
                <Container component="main" maxWidth="sm">
                    <Card className={cardStyles.root}>

                        <Box sx={{ margin: "20px" }} >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Box>
                                    <Typography
                                        component="h1"
                                        variant="h5"
                                        sx={{

                                            display: "flex",
                                            alignItems: "center",
                                            color: "#272782",
                                            fontWeight: "400",
                                            height: "45px",
                                            left: "702px",
                                            top: "340px",
                                            fontStyle: "Roboto-Medium",
                                            fontWeight: "400",
                                            fontSize: "26px",
                                            lineHeight: "42px",
                                        }}
                                    >
                                        RESET PASSWORD
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{

                                        width: "60%",
                                        height: "2px",
                                        backgroundColor: "#272782",
                                        marginTop: "10px",
                                    }}
                                ></Box>
                            </Box>

                            <Box component="form" onSubmit={handleSubmit}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        marginTop: "20px",
                                        marginLeft: "90px",
                                        fontWeight: "600",
                                        fontSize: "18px",
                                        lineHeight: "21px",
                                        color: "#272782",
                                    }}
                                >
                                    <p style={{ fontWeight: "600", fontSize: "16px" }}>Registered APMI ID</p>
                                    <TextField
                                        variant="standard"
                                        required
                                        value={input.newPassword}
                                        name="email"
                                        type="email"
                                        placeholder="Enter ID"
                                        onChange={handleChange}
                                        sx={{
                                            width: "75%",
                                        }}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{
                                            bgcolor: "#272782",
                                            mt: 5,
                                            width: "150px",
                                            borderRadius: 0,
                                            height: 35,
                                            fontWeight: 300,
                                            fontSize: "16px",
                                            lineHeight: "23px",
                                            display: "flex",
                                            align: "center",
                                            color: "#FFFFFF",
                                        }}
                                    >
                                        <span style={{ padding: 10 }}>Send{"     "}</span>
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Card>
                </Container>
            </ThemeProvider>

        </div>
    );
};

export default EmailForResetpassword;